'use strict';

require('../../style/index.less');

require('../../popover/style');

require('../../button/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/popconfirm/style/index.tsx
 ** module id = 810
 ** module chunks = 0
 **/